"use client";
/** The feature flags the API publishes (GET /api/features), fetched once
 *  per session and shared: menus list flag-gated pages only while the
 *  flag is on, so a parked feature never shows a link to a 404. One
 *  request and one cache with useFeatureFlag (lib/features): the two
 *  used to fetch separately, so every page that uses both (the map, the
 *  listings) asked for the flags twice. */
import { useEffect, useState } from "react";
import { fetchFeatures, peekFeatures } from "@/lib/features";

type Flags = Record<string, boolean>;

export function useFeatures(): Flags {
  const [flags, setFlags] = useState<Flags>(() => peekFeatures() ?? {});
  useEffect(() => {
    let alive = true;
    fetchFeatures().then((f) => { if (alive) setFlags(f); });
    return () => { alive = false; };
  }, []);
  return flags;
}

/** Keeps the items whose flag is on (or that have none). */
export function enabledItems<T extends { feature?: string }>(items: T[], flags: Flags): T[] {
  return items.filter((it) => !it.feature || flags[it.feature] === true);
}
